import { mapGetters } from "vuex";

/**
 * A common set of functions to format name
 */
export const nameMixin = {
  computed: {
    ...mapGetters({
      clientNameFormat: "getClientNameFormat",
      clientNameOrder: "getClientNameOrder"
    })
  },
  methods: {
    /**
     * Function to return the first character of the name
     * @param {String} name
     */
    getInitial(name) {
      return name.charAt(0);
    },
    /**
     * Function to format the name based on calendar settings
     * @param {String} firstName
     * @param {String} middleName
     * @param {String} lastName
     * @param {String} namePrefix
     * @param {String} nameSuffix
     */
    formatName(
      firstName,
      middleName,
      lastName,
      namePrefix = null,
      nameSuffix = null,
      credentials = null,
      where = false
    ) {
      let name = "";

      // Step 0: Check if for heading
      if (where === "heading") {
        name = firstName;
        if (middleName !== null) {
          name = name + " " + middleName;
        }
        if (lastName !== null) {
          name = name + " " + lastName;
        }
        if (credentials !== null) {
          name = name + " " + credentials;
        }
        return name;
      } else if (where === "clients") {
        name = lastName + ", " + firstName;
        if (middleName !== null) {
          name = name + " " + middleName;
        }
        if (namePrefix !== null) {
          name = namePrefix + " " + name;
        }
        if (nameSuffix !== null) {
          name = name + " " + nameSuffix;
        }
        return name;
      } else if (where === "chat") {
        name = lastName + ", " + firstName;
        return name;
      }

      // Step 1: Get the format and order of the name
      const clientNameFormat = isNaN(this.clientNameFormat)
        ? 1
        : parseInt(this.clientNameFormat);
      const clientNameOrder = isNaN(this.clientNameOrder)
        ? 1
        : parseInt(this.clientNameOrder);

      // Step 2: Use format to make the name
      switch (clientNameFormat) {
        case 2:
          name = firstName;
          if (namePrefix !== null) {
            name = namePrefix + " " + name;
          }
          if (middleName !== null) {
            name = name + " " + middleName;
          }
          if (lastName !== null) {
            name = name + " " + lastName;
          }
          break;

        case 3:
          name = firstName;
          if (middleName !== null) {
            name = name + " " + this.getInitial(middleName);
          }
          if (lastName !== null) {
            name = name + " " + lastName;
          }
          break;

        case 4:
          name = firstName;
          if (lastName !== null) {
            name = name + " " + lastName;
          }
          break;

        case 5:
          name = firstName;
          break;

        case 6:
          name = this.getInitial(firstName);
          if (lastName !== null) {
            name = name + " " + lastName;
          }
          break;

        case 7:
          name = this.getInitial(firstName);
          if (lastName !== null) {
            name = name + " " + this.getInitial(lastName);
          }
          break;

        default:
          name = firstName;
          if (namePrefix !== null) {
            name = namePrefix + " " + name;
          }
          if (middleName !== null) {
            name = name + " " + middleName;
          }
          if (lastName !== null) {
            name = name + " " + lastName;
          }
          if (nameSuffix !== null) {
            name = name + " " + nameSuffix;
          }
      }

      // Step 3: Use order to order the name
      if (clientNameOrder === 1) {
        name = name
          .split(" ")
          .reverse()
          .join(" ");
      }

      // Step 4: Return result
      return name;
    }
  }
};
